import { createRouter, createWebHistory } from 'vue-router'
import { fetchSeoConfig, getRouteSEO, setPageSEO } from '@/utils/seo'
import { recordPageVisit } from '@/utils/stats'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: { title: '首页 - 长春合利水土保持科技有限公司' }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/About.vue'),
    meta: { title: '关于我们 - 长春合利水土保持科技有限公司' }
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('@/views/Products.vue'),
    meta: { title: '产品中心 - 长春合利水土保持科技有限公司' }
  },
  {
    path: '/services',
    name: 'Services',
    component: () => import('@/views/Services.vue'),
    meta: { title: '技术服务 - 长春合利水土保持科技有限公司' }
  },
  {
    path: '/product/:id',
    name: 'ProductDetail',
    component: () => import('@/views/ProductDetail.vue'),
    meta: { title: '产品详情 - 长春合利水土保持科技有限公司' }
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('@/views/News.vue'),
    meta: { title: '新闻动态 - 长春合利水土保持科技有限公司' }
  },
  {
    path: '/news/:id',
    name: 'NewsDetail',
    component: () => import('@/views/NewsDetail.vue'),
    meta: { title: '新闻详情 - 长春合利水土保持科技有限公司' }
  },
  {
    path: '/hr',
    name: 'Hr',
    component: () => import('@/views/Hr.vue'),
    meta: { title: '招聘信息 - 长春合利水土保持科技有限公司' }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('@/views/Contact.vue'),
    meta: { title: '联系我们 - 长春合利水土保持科技有限公司' }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// 路由守卫 - 设置页面标题和SEO信息，并记录访问统计
let seoConfigLoaded = false

router.beforeEach(async (to, from, next) => {
  // 首次加载时获取SEO配置
  if (!seoConfigLoaded) {
    const seoConfig = await fetchSeoConfig()
    seoConfigLoaded = true
    
    // 根据路由设置SEO
    const routeSEO = getRouteSEO(to.name, seoConfig)
    if (routeSEO && routeSEO.title) {
      setPageSEO(routeSEO)
    } else {
      // 使用默认标题
      document.title = to.meta.title || '长春合利水土保持科技有限公司'
    }
  } else {
    // SEO配置已加载，直接设置
    const seoConfig = await fetchSeoConfig()
    const routeSEO = getRouteSEO(to.name, seoConfig)
    if (routeSEO && routeSEO.title) {
      setPageSEO(routeSEO)
    } else {
      document.title = to.meta.title || '长春合利水土保持科技有限公司'
    }
  }
  
  // 记录页面访问统计（异步，不阻塞）
  setTimeout(() => {
    recordPageVisit(to.path, to.meta.title || document.title)
  }, 100)
  
  next()
})

export default router
